// extracted by mini-css-extract-plugin
export default {"single":"Notification_single__W7E64","filename":"Notification_filename__o-umR","upload_success_icon":"Notification_upload_success_icon__ZGVEG"};